import "./index.css";
import { useSelector } from "react-redux";
import CardContainer from "../../_utils/CommonViewAllCard/CardContainer";
import TitleSubtitlePair from "../TitleSubtitlePair";
import PrimaryButton from "../CommonButtons/PrimaryButton";
import FormatAmount from "../FormatAmount/FormatAmount";
import TextWithIcon from "../CommonViewAllCard/CardSubComponent/TextWithIcon";
import CardActionableButton from "../CommonViewAllCard/CardSubComponent/CardActionableButton";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

const CommonReminderCard = ({
  data,
  toggle,
  txnId,
  hasModService,
  navigate,
  filterRef,
  setShowModal,
  setSelectedTxnData,
  setReminderDeletePrompt,
}) => {
  const services = useSelector((state) => state.refreshToken.services);

  const formatDate = (value) => {
    let dateObj = new Date(value);

    let day = dateObj.getDate();
    let year = dateObj.getFullYear();
    let month = dateObj.toLocaleString("default", { month: "short" });
    let formattedDate = `${day} ${month}, ${year}`;

    if (formattedDate == null || formattedDate == undefined) {
      return "NA";
    } else {
      return formattedDate;
    }
  };
  return (
    <div className="standard-reminder-card-alignment gap-x-gap-sm gap-y-gap-md">
      {data?.map((val) => {
        return (
          <>
            <CardContainer
              key={val?.id}
              filterRef={filterRef}
              hoverHeight={GlobalConfiguration?.reminderCardHoverHeight}
              onClickHandler={() => {}}
            >
              <card-body>
                <div className="group flex flex-col w-full h-full gap-y-gap-sm">
                  <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                    <div className="w-full flex justify-between items-center ">
                      <p
                        className={`text-font-sm flex-1 truncate  text-text-primary font-normal}`}
                      >
                        Reminder {val?.id}
                      </p>

                      {!toggle && (
                        <div className="gap-x-gap-sm ml-margin-sm justify-end">
                          <CardActionableButton
                            handleFunction={(e) => {
                              txnId(val?.id);
                              if (hasModService) {
                                setReminderDeletePrompt(true);
                              } else {
                                e.stopPropagation();
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "AReminder",
                                  },
                                });
                              }
                            }}
                            icon={
                              "https://q2pay.in/new_assets/common/view_all/delete.svg"
                            }
                            isDisabled={!hasModService}
                            bgColor="var(--primary-nav)"
                            hoverOption="white"
                            title={"delete"}
                          />
                        </div>
                      )}
                    </div>
                    <p className="flex text-font-xs transform-none text-text-secondary">
                      Name
                    </p>
                  </div>

                  <TextWithIcon
                    text={formatDate(val?.reminder_date)}
                    subText="Date"
                    fontWeight={"normal"}
                    textColor={"var(--text-primary)"}
                  />
                  <TextWithIcon
                    text={
                      val?.amount ? (
                        <>
                          INR <FormatAmount price={Number(val?.amount)} />
                        </>
                      ) : (
                        "N/A"
                      )
                    }
                    subText="Amount (optional)"
                    fontWeight={"semibold"}
                    textColor={
                      val?.amount ? "var(--settled)" : "var(--text-primary)"
                    }
                  />

                  <div className="remark-wrapper relative px-padding-sm overflow-hidden transition-all duration-animation-medium ease-in-out max-h-dropdown-option-height-md group-hover:max-h-remindercard-max-height break-all">
                    <TitleSubtitlePair
                      title={val?.reminder_remark}
                      subtitle="Remark"
                      variant="sm"
                      titleColor="text-primary"
                      truncate={true}
                    />
                  </div>

                  {!toggle && (
                    <div className={`flex justify-end px-padding-sm`}>
                      <PrimaryButton
                        btnText="Create transaction"
                        handleFunction={(e) => {
                          if (
                            services?.includes("CBeneficiaryTxn") ||
                            services?.includes("CInternalTxn")
                          ) {
                            setSelectedTxnData({
                              reminderRemark: val?.reminder_remark,
                              reminderAmount: val?.amount || "",
                            });
                            setShowModal(true);
                          } else {
                            e.stopPropagation();
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService:
                                  "CBeneficiaryTxn,CInternalTxn",
                              },
                            });
                          }
                        }}
                        isDisabled={
                          !services?.includes("CBeneficiaryTxn") &&
                          !services?.includes("CInternalTxn")
                        }
                        enabledBgColor="var(--primary-act)"
                        enabledTextColor="var(--text-primary)"
                        fullWidthRequired={true}
                        hoverOption="white"
                      />
                    </div>
                  )}
                </div>
              </card-body>
            </CardContainer>
          </>
        );
      })}
    </div>
  );
};

export default CommonReminderCard;
